import React from 'react';
import Markdown from '../Markdown/Markdown';
import styles from './TextSectionMarkdown.module.css';
import { extractColors } from '@utils/utils';

type Props = {
  markdown: string;
  textColor: string;
  backgroundColor: string;
  className?: string;
};

export default function TextSectionMarkdown({
  markdown,
  textColor,
  backgroundColor,
}: Props): JSX.Element {
  return (
    <div
      style={{
        color: extractColors(textColor),
        backgroundColor: extractColors(backgroundColor),
      }}
      className={'text-section-markdown ' + styles['text-section-markdown']}
    >
      <Markdown markdown={markdown} />
    </div>
  );
}
